import {getAuthorModal} from "./getAuthorModal";
import {getCommunityUserModal} from "../modal/getCommunityUserModal";
export function initAuthor() {
    $(document).on("click", ".js-post-author-link", function (e) {
        e.preventDefault();
        var authorID = $(this).data("id");
        var modal = $("#author_profile_modal_" + authorID);
        if (modal.length) {
            modal.modal("show");
        } else {
            getAuthorModal(authorID);
        }
    });
    $(document).on("click", ".display_comment a", function (e) {
        e.preventDefault();
        var clickedClassName = $(this).attr("class");
        if (clickedClassName === "name" || clickedClassName === "image") {
            var link = $(this).attr("href");
            var linkArray = link.split("/");
            var nickname = linkArray[linkArray.length - 2];
            var modal = $("#community_user_profile_modal_" + nickname);
            if (modal.length) {
                modal.modal("show");
            } else {
                getCommunityUserModal(nickname);
            }
        }
    });
}